import {ContratMenuConviveDecoupage__PlcDTO} from '../../contratmenuconvivedecoupage__plc-dto';
import {Cmcr__CmcCa__PlcDto} from '../../cmcr__cmcca__plc-dto';

/**
 * Planning d'une période à enregistrer pour un point de livraison :
 * ouvertures, effectifs et coûts prévisionnels des régimes, taux de prise prévisionnels des plats
 */
export class SavePlanningPlcDTO {

  idCmcMn: number;

  /** Taux de prise prévisionnels saisis à l'écran, par plat */
  tauxDePrisePlcList: ContratMenuConviveDecoupage__PlcDTO[] = [];

  /** Ouvertures, effectifs et coûts prévisionnels saisis à l'écran, par régime */
  effectifRegimePlcList: Cmcr__CmcCa__PlcDto[] = [];

  constructor(idCmcMn: number, tauxDePrisePlcList: ContratMenuConviveDecoupage__PlcDTO[],
              effectifRegimePlcList: Cmcr__CmcCa__PlcDto[]) {
    this.idCmcMn = idCmcMn;
    this.tauxDePrisePlcList = tauxDePrisePlcList;
    this.effectifRegimePlcList = effectifRegimePlcList;
  }
}
